'use client';

import classNames from 'classnames';
import { ReactNode } from 'react';
import Nav from 'react-bootstrap/Nav';

import { useScrollSpy } from './useScrollSpy';

type InPageNavItem = {
  // Fragment link to a section of the current page, e.g. '#overview'
  href: string;
  label: ReactNode;
};

type InPageNavProps = {
  items: InPageNavItem[];
  className?: string;
};

/**
 * Right-column navigation for the sections of a single page.
 *
 * Renders the anchor links and highlights the section the user is currently
 * looking at as they scroll. Use for the in-page menus on data pages
 * (dataset, entity, country, program); docs pages have `TableOfContents`.
 */
export function InPageNav({ items, className }: InPageNavProps) {
  const activeId = useScrollSpy(items.map((item) => item.href.replace(/^#/, '')));

  return (
    <Nav variant="pills" className={classNames('flex-column', 'd-print-none', 'd-none', 'd-md-flex', className)}>
      {items.map((item) => {
        const active = item.href.replace(/^#/, '') === activeId;
        return (
          <Nav.Link
            key={item.href}
            href={item.href}
            active={active}
            aria-current={active ? 'location' : undefined}
          >
            {item.label}
          </Nav.Link>
        );
      })}
    </Nav>
  );
}
